export default "__VITE_ASSET__52cf8a95__"